const OPEN_CONTEXT_MENU = 'OPEN_CONTEXT_MENU';
const CLOSE_CONTEXT_MENU = 'CLOSE_CONTEXT_MENU';

export {
  OPEN_CONTEXT_MENU,
  CLOSE_CONTEXT_MENU,
};
